import { inject } from 'aurelia';
import { INavigationOptions, IRouteViewModel, Params, RouteNode } from '@aurelia/router';
import { lifecycleHooks } from '@aurelia/runtime-html';
import { UserContext } from '../contexts/user-context';
import { ProjectModelService } from '../services/project-model-service';

@lifecycleHooks()
@inject(UserContext, ProjectModelService)
export class AuthorizationHook {
    constructor(
        private readonly _userContext: UserContext,
        private readonly _projectModelService: ProjectModelService,
    ) { }

    public canLoad(
        _viewModel: IRouteViewModel,
        params: Params,
        next: RouteNode,
        _current: RouteNode | null,
        _options: INavigationOptions,
    ): boolean | string {
        if (!next?.data?.requiresEditAccess) {
            return true;
        }

        if (this._userContext.isLoggedIn) {
            return true;
        }

        // An event that has not been saved exists only in memory, so anyone can build it. Logging in is required
        // when saving (event summary), and the backend enforces access to everything that is stored.
        return this._isEditingUnsavedDraft(params?.eventId) ? true : 'login';
    }

    private _isEditingUnsavedDraft(eventId: unknown): boolean {
        const draft = this._projectModelService.currentModel;
        if (draft == null || draft.event.code != null) {
            return false;
        }

        // Routes without an event id (edit-teams, edit-schedule, ...) always work on the current draft.
        return eventId == null || eventId === draft.event.id;
    }
}
